import React, { Component } from 'react';
import classes from "./Chart_Village_Person_Board.module.css";
import Chart_Village_Gender_LineChart from './Chart_Village_Gender_LineChart';

export default class Chart_Village_Gender_Board extends Component {

    render() {
        return (
            <div className={classes.container}>
            <p>The intersection of Gender and Personalities show some interesting relationships. For example, there are no Females who are Cranky, Jocks, Lazy, or Smug while there are no Males who are Normal, Peppy, Sisterly, or Snooty.</p>              
                <Chart_Village_Gender_LineChart />    
            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/